import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { apiConfig, auth0Config } from "../../config";
import { getBasicAuthConfig } from "../authUtils";
import { CreateInvoice } from "../../types/v5/Invoice";
import { Account, AccountStats } from "../../types/v5/account";
import { Paginated } from "../../types/pagination";

const urlPath = "accounts";

class AccountApi {
  private auth0Client: Auth0Client | null = null;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
  }

  async find(query: Record<string, unknown>, signal?: AbortSignal) {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .get<Paginated<Account>>(`${apiConfig.billingServiceBase}/${urlPath}`, {
        ...config,
        params: query,
        ...(signal && { signal }),
      })
      .then((res) => res.data);
  }

  async findById(id: string) {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .get<Account>(`${apiConfig.billingServiceBase}/${urlPath}/${id}`, {
        ...config,
      })
      .then((res) => res.data);
  }

  async create(data: CreateInvoice) {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .post<Account>(`${apiConfig.billingServiceBase}/${urlPath}`, data, {
        ...config,
      })
      .then((res) => res.data);
  }

  // extra endpoints
  async stats(subjectId: string): Promise<AccountStats> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .get(`${apiConfig.billingServiceBase}/${urlPath}/${subjectId}/stats`, {
        ...config,
      })
      .then((res) => res.data);
  }

  // stats for organization
  async totalStats(): Promise<{
    totalBalance: number;
    data: { name: number; value: number }[];
  }> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .get(`${apiConfig.billingServiceBase}/${urlPath}/stats`, {
        ...config,
      })
      .then((res) => res.data);
  }
}

const accountApi = new AccountApi();

export default accountApi;
